/**
 * 图片基线 · 迭代谱系 API（与迭代视图组件同域）
 */
import { platformFetch } from '../../../platform/http';
import type { GenerationMode } from '../../../services/api';

export interface IterationGraphNode {
  id: string;
  jobId: string;
  imageUrl: string;
  prompt: string;
  model: string;
  size: string;
  quality: string;
  mode: GenerationMode;
  parentId: string | null;
  childrenIds: string[];
  generation: number;
  createdAt: number;
  status: string;
  errorMessage: string | null;
  isDeleted: boolean;
}

export const iterationAPI = {
  // 获取迭代谱系数据
  async getIterationGraph(): Promise<{
    nodes: IterationGraphNode[];
    rootNodes: IterationGraphNode[];
  }> {
    const response = await platformFetch('/images/iteration-graph');
    if (!response.ok) throw new Error('获取迭代谱系失败');
    return response.json();
  },
};
